import React from "react";
import { useTranslation } from "react-i18next";

//Material-UI Core Components
import Box from '@mui/material/Box';
import AppPage from "@/ui/AppPage/AppPage";
import Dashboard from "../HomePage/Dashboard";

//Custom Components

function OperationsHomePage() {
  const { t } = useTranslation();

  return (
    <AppPage>
      <Box m={2}>
          {/* TODO: add real content */}
        <Dashboard />
      </Box>
    </AppPage>
  );
}

export default OperationsHomePage;
